import axios, { AxiosError, AxiosResponse } from 'axios';
import blobErrorToObject from 'helpers/blobErrorToObject';

const auth_instance = axios.create({
  baseURL: window.REACT_APP_EXTERNAL_AUTH !== 'REPLACE_REACT_APP_EXTERNAL_AUTH' ? window.REACT_APP_EXTERNAL_AUTH : process.env.REACT_APP_EXTERNAL_AUTH || 'https://test.tazadeal.com/auth', // http://localhost:8000/api',
  headers: { 'Access-Control-Allow-Origin': '*' },
  withCredentials: true,
});

auth_instance.interceptors.response.use(( response: AxiosResponse ) => {
  return response
}, async (error: AxiosError<any>) => {
  if (error?.response?.data.constructor.name === 'Blob'){
    error.response.data = await blobErrorToObject(error?.response?.data)
  };
  return Promise.reject(error)
});

const getLoginUrl = (payload: FormData) => auth_instance.post<any>('/blitz/login/url/', payload);
const logoutHandle = (token: string) => auth_instance.post<any>('/blitz/logout/url/', {}, { headers: { 'Authorization': `Bearer ${token}` } });

const refreshBlitzTokens = (payload: { refresh_token: string }) => auth_instance.post<any>('/blitz/auth/refresh/', payload.refresh_token);

const external_auth = {
  getLoginUrl,
  logoutHandle,
  refreshBlitzTokens,
};

export default external_auth;
